import React from "react";
import { styledLink } from "./LinkWithIcon.css";

type Props = JSX.IntrinsicElements["a"] & {
  icon: React.ReactNode;
  title: string;
};

export const LinkWithIcon: React.FC<Props> = ({
  icon,
  title,
  href,
  className,
  ...props
}) => {
  return (
    <a
      role="menuitem"
      className={className ? `${className} ${styledLink}` : styledLink}
      href={href}
      {...props}
    >
      {icon}
      <p>{title}</p>
    </a>
  );
};
